import React from 'react';

import exitIcon from '#src/assets/starterDashboardV2/readyToShare/exitIcon.svg';
import petitionImageOverlay from '#src/assets/starterDashboardV2/readyToShare/petitionImageOverlay.svg';

import { BodyLoading } from './Body.loading';
import {
	BodyStyles,
	ExitIconStyles,
	MessageStyles,
	PetitionImageOverlayStyles,
	PetitionImageStyles,
	PetitionInfoStyles,
	PetitionTitleStyles,
} from './Body.styles';
import type { RedditPostComponentsProps } from './types';

export const Body: React.FC<RedditPostComponentsProps> = (props) => {
	const {
		size,
		message,
		petition: { ask, photo },
		loading,
		retryState,
	} = props;

	const photoUrl = photo?.petitionSmall.url;

	if (loading) return <BodyLoading size={size} retryState={retryState} />;

	return (
		<div className={BodyStyles({ size })}>
			<div className={PetitionInfoStyles({ size })}>
				<p className={PetitionTitleStyles({ size })}>{ask}</p>
				<div className={PetitionImageStyles({ size })}>
					{photoUrl && <img className="h-full w-full object-cover" src={photoUrl} alt="" aria-hidden />}
					{!photoUrl && <div className="bg-icon-weaker h-full w-full" aria-hidden></div>}
					<img src={petitionImageOverlay} className={PetitionImageOverlayStyles({ size })} aria-hidden alt="" />
					<img src={exitIcon} className={ExitIconStyles({ size })} alt="" aria-hidden />
				</div>
			</div>
			<div className={MessageStyles({ size })}>{message}</div>
		</div>
	);
};
